import React from "react";
import "./Policy.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

const CodeOfEthics = () => {
  return (
    <>
      <Header />
      <div className="policy-container">
        <div className="policy-content">
          <h2>Código de Ética</h2>
          <p className="paragrafo">
            <b>Objetivo:</b> Instruir o colaborador através do código de ética
            da empresa à condução do negócio obedecendo as leis vigentes.
          </p>
          <h4 className="subtitulo">1. INTRODUÇÃO</h4>
          <p className="paragrafo">
            Na JTD TRANSPORTES LTDA, devemos sempre agir com integridade
            profissional e demonstrar o nosso compromisso com as mais elevadas
            normas éticas. <br />
            <br />
            Com a adoção deste Código, reforçamos a prática de um ambiente
            saudável de trabalho e de negócios que estimule a ética, o respeito
            mútuo e a integridade física e moral de todos. <br />
            <br />
            Se estiver indeciso sobre algum tipo de conduta, pergunte a si
            mesmo:
          </p>
          <h4 className="subtitulo">
            REFLETIRÁ BEM PARA MIM E PARA A JTD TRANSPORTES? GOSTARIA QUE ISSO
            SE TORNASSE PÚBLICO?
          </h4>
          <p className="paragrafo">
            Se continuar na dúvida quanto à resposta, não adote o comportamento.
            Apesar de o Código fornecer diversas orientações sobre os padrões de
            conduta em nossos negócios, reconhecemos que nenhum documento é
            capaz de compreender todas as situações práticas possíveis. <br />
            <br />O Código não contém todas as respostas. É um instrumento para
            facilitá-lo na adoção da conduta apropriada no exercício
            profissional. Também não substitui nosso dever de utilizar o bom
            senso e solicitar a opinião de outros colaboradores sobre a melhor
            conduta a ser praticada.
          </p>
          <h4 className="subtitulo">2. COMPROMISSOS CORPORATIVOS</h4>
          <h4 className="subtitulo">2.1 Cumprimento da Lei</h4>
          <p className="paragrafo">
            – A JTD, na condução do seu negócio, obedece às leis vigentes,
            respeita a livre concorrência e o meio ambiente, repudia qualquer
            prática discriminatória e preconceituosa, a exploração de mão de
            obra infantil, o trabalho escravo ou degradante e a corrupção em
            todas, mas suas formas, inclusive na sua relação com fornecedores e
            parceiros.
          </p>
          <h4 className="subtitulo">2.2 Respeito às Pessoas</h4>
          <p className="paragrafo">
            – A JTD, em seu ambiente de trabalho, valoriza a diversidade, a
            cortesia, a imparcialidade, o respeito às pessoas e repudia os atos
            discriminatórios, de assédio e retaliações. <br />
            <br />
            O respeito e a ordem devem prevalecer no ambiente de trabalho de
            forma a coibir atos de assédio moral, econômico e sexual ou
            situações que configurem pressões, intimidações ou ameaças no
            relacionamento entre os colaboradores, estagiários, fornecedores
            e/ou prestadores de serviços, independentemente de seu nível
            hierárquico. <br />
            <br />
            Assim como respeitamos os nossos clientes externos, cobramos a mesma
            conduta de todos a relação cliente interno versus fornecedor
            interno.
          </p>
          <h4 className="subtitulo">2.3 Propriedade Intelectual</h4>
          <p className="paragrafo">
            – Conforme Política de Uso de Internet e Recursos de Tecnologia –
            Versão 1.0 – JTD TRANSPORTES LTDA
          </p>
          <h4 className="subtitulo">2.4 Confidencialidade</h4>
          <p className="paragrafo">
            O uso de informações classificadas como confidenciais deve ser
            exclusivamente para fins profissionais, sendo proibido utilizá-las
            em benefício próprio ou de terceiros com a finalidade diversa
            daquela para a qual a informação foi divulgada/recebida. <br />
            <br />
            Todos os colaboradores, estagiários, fornecedores e prestadores de
            serviços com acesso a informações confidenciais devem assinar o
            Termo de Confidencialidade para preservar as informações
            estratégicas da JTD e/ou de seus clientes e garantir o sigilo
            absoluto das informações obtidas e geradas no desempenho de suas
            atividades. <br />
            <br />O sigilo das informações é exigido de todos nós da JTD durante
            e após a vigência do contrato que estabelecer o vínculo com a JTD.
          </p>
          <h4 className="subtitulo">2.5 Conflito de Interesses</h4>
          <p className="paragrafo">
            Em um ambiente corporativo, é inevitável que sejam identificados
            alguns conflitos de ordens diversas. <br />
            <br />
            No que diz respeito ao Conflito Externo de Interesses, primando por
            uma relação ética e transparente com os nossos clientes, uma vez
            identificado possível conflito de interesses, os clientes devem ser
            imediatamente comunicados. Confirmado o conflito, declinamos da
            proposta, agradecendo e informando o motivo. <br />
            <br />
            Quanto ao Conflito Interno de Interesses, devemos observar as
            seguintes regras: <br />
            <br />
            Prevalece o compromisso ético da JTD, abdicando de qualquer
            interesse pessoal. Como interesse pessoal entende-se toda vantagem
            material ou moral a favor próprio ou a favor de parentes,
            familiares, amigos ou pessoas com as quais haja relações pessoais,
            comerciais ou políticas. <br />
            <br />
            Sendo assim é proibido: <br />
            <br />• Adquirir ações de empresas/clientes com base em informações
            privilegiadas ou até mesmo fornecer essas informações a terceiros;{" "}
            <br />
            <br />
            • Manter ou contratar parentes de primeiro ou segundo grau (pai,
            mãe, filhos, irmãos e tios) e cônjuges em funções em que exista uma
            relação hierárquica, direta ou indireta, ou que respondam ao mesmo
            superior imediato. <br />
            <br />• A contratação de empresas prestadoras de serviço cujo sócio
            ou sócios sejam parentes em 1º ou 2º grau de algum colaborador do
            Grupo JTD só pode ser efetuada após aprovação formal do Diretor da
            JTD. <br />
            <br />
            – Quanto ao conflito causado por relação pessoal no ambiente de
            trabalho: <br />
            <br />
            Respeitamos o direito de as pessoas relacionarem-se livremente.
            Todavia, nas relações de parentesco, de amizade ou romance,
            espera-se o bom senso e o compromisso com a empresa a fim de que o
            fato não afete o desempenho dos envolvidos ou cause desconforto aos
            colegas de trabalho. Em casos de relacionamentos familiares e/ou
            amorosos, é proibida a subordinação direta entre uma das partes,
            salvo se aprovados previamente pelo Diretor da JTD. <br />
            <br />
            Situações não explicitadas neste Código que possam acarretar
            conflito de interesses devem ser informadas ao superior hierárquico
            direto para orientação
          </p>
          <h4 className="subtitulo">2.6 Práticas Antissuborno</h4>
          <p className="paragrafo">
            Presentes e brindes recebidos de valor superior a 1/2 (metade) do
            salário mínimo vigente devem ser imediatamente comunicados ao gestor
            para que sejam sorteados entre os colaboradores da empresa ou
            devolvidos ao remetente, quando se tratarem de presentes de
            expressivo valor. Ocorrendo sorteio ou devolução de presente,
            deve-se enviar uma carta-padrão de agradecimento. <br />
            <br />É proibido oferecer ou receber qualquer forma de suborno ou
            praticar qualquer ato de corrupção (ativa ou passiva) com o intuito
            de exercer influência sobre qualquer dirigente público ou entidades
            públicas com o fim de obter ou manter negócio para a JTD, para si
            próprio ou para terceiros, conforme as leis nacionais e/ou
            internacionais antissuborno ou anticorrupção aplicáveis à JTD e/ou
            aos seus clientes.
          </p>
          <h4 className="subtitulo">2.7 Responsabilidade Socioambiental</h4>
          <p className="paragrafo">
            A JTD, em suas dependências e campanhas internas, estimula e conta
            com seus colaboradores na preservação do meio ambiente e na
            reciclagem de materiais. <br />
            <br />A JTD também estimula e conta com a participação dos
            colaboradores em práticas sociais, ambientais e de voluntariado, a
            fim de promover o desenvolvimento das comunidades e a melhoria na
            qualidade de vida.
          </p>
          <h4 className="subtitulo">3. SEGURANÇA DAS INFORMAÇÕES</h4>
          <h4 className="subtitulo">3.1 Sistemas Eletrônicos de Informação</h4>
          <p className="paragrafo">
            O uso de informações classificadas como confidenciais deve ser
            exclusivamente para fins profissionais, sendo proibido utilizá-las
            em benefício próprio ou de terceiros com a finalidade diversa
            daquela para a qual a informação foi divulgada/recebida. <br />
            <br />O sigilo das informações é exigido de todos nós da JTD durante
            e após a vigência do contrato que estabelecer o vínculo com a JTD.{" "}
            <br />
            <br />
            Para regular o uso dos sistemas eletrônicos da JTD, foi estabelecida
            a “Política de uso da internet e Recursos de Tecnologia”, no
            servidor local, ou impressa, acessível a todos os colaboradores.
          </p>
          <h4 className="subtitulo">4. CONVIVÊNCIA E USO DAS INSTALAÇÕES</h4>
          <h4 className="subtitulo">4.1 Ambiente de Trabalho</h4>
          <p className="paragrafo">
            • A comercialização de quaisquer produtos dentro das dependências da
            JTD; <br />
            <br />
            • Deixar material pessoal e de trabalho acumulado nas estações de
            trabalho; <br />
            <br />• O uso de equipamentos sonoros ou conversas em tom elevado, a
            ponto de causar desconforto aos demais colaboradores, visitantes e
            até mesmo clientes.
          </p>
          <h4 className="subtitulo">4.2 Uso de Drogas e Porte de Armas</h4>
          <p className="paragrafo">
            Prezando pela segurança e boa convivência entre os colaboradores,
            estagiários e prestadores de serviço da JTD, proibimos
            expressamente: <br />
            <br />
            • Consumir bebidas alcoólicas e drogas durante o horário de
            trabalho; <br />
            <br />
            • Fumar dentro de ambientes fechados da empresa; <br />
            <br />
            • Acessar as dependências da empresa sob o efeito de substâncias
            entorpecentes, lícitas ou ilícitas; <br />
            <br />• Portar armas, exceto colaboradores ou prestadores
            autorizados a realizar o serviço de segurança e vigilância
            patrimonial.
          </p>
          <h4 className="subtitulo">4.3 Proteção dos Ativos</h4>
          <p className="paragrafo">
            Cabe a todos preservar todos os bens da empresa, tais como móveis,
            máquinas e equipamentos. <br />
            <br />
            Sendo assim, é proibido: <br />
            <br />
            • Comer nas estações de trabalho; <br />
            <br />
            • Colar qualquer papel ou foto nas paredes e mesas; <br />
            <br />
            • Transportar equipamento da empresa sem autorização prévia do
            Gestor; <br />
            <br />• Realizar qualquer tipo de reparo nos equipamentos da
            empresa, tais como computadores, aparelhos de celular, impressoras
            etc.
          </p>
          <h4 className="subtitulo">5. DISPOSIÇÕES FINAIS</h4>
          <h4 className="subtitulo">5.1 Responsabilidade</h4>
          <p className="paragrafo">
            Os colaboradores da JTD são indistintamente responsáveis por fazer
            com que todas as orientações e normas instituídas neste Código sejam
            entendidas e postas em prática.
          </p>
          <h4 className="subtitulo">5.2 Infrações e Penalidades</h4>
          <p className="paragrafo">
            O descumprimento deste Código implicará penalidades de acordo com a
            gravidade do fato, podendo ser aplicada advertência, suspensão ou
            rescisão contratual. <br />
            <br />
            Qualquer pessoa que constatar qualquer prática ou ato que sejam
            contrários aos estabelecidos neste Código de Conduta deverá
            comunicar o ocorrido ao seu gestor, que, por sua vez, tem a
            obrigação de reportar o fato ao diretor da empresa. Se preferir
            informar a ocorrência de forma anônima, poderá realizá-la através de
            um formulário, que será depositado na caixa de reclamações
            localizada no refeitório da empresa.
          </p>
          <h4 className="subtitulo">5.3 Vigência</h4>
          O Código de Conduta entra em vigor a partir de sua divulgação, sem
          previsão para término. <br />
          <br />
          Em relação a seu conteúdo, estão previstas revisões sistemáticas,
          podendo haver alterações a qualquer tempo, conforme a necessidade.{" "}
          <br />
          <br />
          Qualquer alteração do Código será comunicada a todos os Colaboradores
          da <b>JTD TRANSPORTES LTDA</b>.
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default CodeOfEthics;
